import {
  cloneElement,
  memo,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  NativeScrollEvent,
  NativeSyntheticEvent,
  Platform,
  View,
} from 'react-native';

export const HorizontalScrollWrapper = memo(({children}: PropsWithChildren) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<any>(null);
  const [scrollX, setScrollX] = useState(0);

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const el = wrapperRef.current;
    const onWheel = (e: WheelEvent) => {
      e.preventDefault();
      //@ts-ignore
      const newOffset = scrollX + e.deltaY;

      scrollRef.current?.scrollToOffset?.({
        offset: newOffset,
        animated: false,
      });
    };
    //@ts-ignore
    el?.addEventListener('wheel', onWheel, {passive: false});
    //@ts-ignore
    return () => el?.removeEventListener('wheel', onWheel);
  }, [scrollX]);

  const handleScroll = (e: NativeSyntheticEvent<NativeScrollEvent>) => {
    setScrollX(e.nativeEvent.contentOffset.x);
  };

  return (
    <View ref={wrapperRef as any}>
      {cloneElement(children as any, {
        ref: scrollRef,
        onScroll: handleScroll,
        scrollEventThrottle: 16,
      })}
    </View>
  );
});
